<template>
  <van-popup :value="visible" :close-on-click-overlay="false">
    <div class="dialog_wrapper">
      <slot />
    </div>
  </van-popup>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    }
  }
};
</script>
<style scoped>
.van-popup {
  background-color: transparent;
}
  .van-overlay {
    background-color: rgba(0, 0, 0, 0.4);
}
  .dialog_wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
</style>